import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import i18n from '../../i18n/config';

const useCases = [
  {
    id: 1,
    key: 'loan_use_cases.new_car',
    color: '#1abc9c'
  },
  {
    id: 2,
    key: 'loan_use_cases.business_development',
    color: '#3498db'
  },
  {
    id: 3,
    key: 'loan_use_cases.perfect_home',
    color: '#f1c40f'
  },
  {
    id: 4,
    key: 'loan_use_cases.for_daily_use',
    color: '#e74c3c'
  },
  {
    id: 5,
    key: 'loan_use_cases.dream_vacation',
    color: '#F9FAFB'
  }
];

const AnimatedUseCases: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % useCases.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-12 overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="inline-block px-4 py-2 font-medium mb-4"
          style={{
            backgroundColor: `${useCases[currentIndex].color}30`,
            color: useCases[currentIndex].color
          }}
        >
          {i18n.t(useCases[currentIndex].key)}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default AnimatedUseCases; 